import { Box, SectionHelper, Text } from "@wix/design-system";
import React, { useContext, useState } from "react";
import { RicosContext } from "./../../../ricos-context/index.js";
const LS_KEY = "ricos/link-modal/not-published-warning/closed";
const NotPublishedWarning = () => {
  const { t } = useContext(RicosContext);
  const [isClosed, setIsClosed] = useState(() => !!localStorage?.getItem(LS_KEY));
  const onClose = () => {
    localStorage?.setItem(LS_KEY, "true");
    setIsClosed(true);
  };
  if (isClosed) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(SectionHelper, { appearance: "standard", onClose, showCloseButton: true, size: "small" }, /* @__PURE__ */ React.createElement(Box, { gap: "SP2" }, /* @__PURE__ */ React.createElement(Text, { size: "small" }, t("LinkSettings_NotPublishedWarning_Text"))));
};
export {
  NotPublishedWarning
};
//# sourceMappingURL=not-published-warning.js.map
